import api from './api';


// class with functions for ship api calls 
class ShipService {

  //get list of ships backup 
  getShips() {

    return api.get('https://vop.olympusmarinegroup.com:8083/vop/v1/shipbasic');

  }

  //get list of ships 
  getShipsAuth() {

    return api.get('Ships/');

  }

}

export default new ShipService();
